export function updateNote(currentNote, nested, key, value) {
  const clonedNote = structuredClone(currentNote);

  if (nested) {
    clonedNote.content[key] = structuredClone(value);
  } else {
    clonedNote[key] = structuredClone(value);
  }

  return clonedNote;
}
